<template>
	<footer class="ly_footer">
		<div class="contact contents-article">
			<dl>
				<dt>기업고객센터</dt>
			</dl>

			<div class="btn-area">
				<button type="button" id="channel_service">실시간 채팅 상담</button>
				<button type="button" @click.prevent="$router.push({ name: 'qna' })">1:1 문의</button>
			</div>

			<ul class="cs-operation">
				<li>
					<div class="contact">
						<strong
							><i class="ico-bull">&bull;</i> 모바일 쿠폰 문의<a href="tel:1588-0108" class="tel">1588-0108</a>
						</strong>
					</div>

					<div class="operating-hours">
						<span>운영시간 : 평일 09:00 ~ 18:00</span>
						<span class="break-time">(점심)12:00 ~ 13:00</span>
					</div>
				</li>

				<li>
					<div class="contact panchok">
						<strong>
							<i class="ico-bull">&bull;</i> 판촉 제작 문의<a href="tel:1588-4230" class="tel">1588-4230</a>
							<i class="line"></i>
							<a href="mailto:gift.biz@kt.com" class="email">gift.biz@kt.com</a>
						</strong>
					</div>
					<div class="operating-hours">
						<span>운영시간 : 평일 09:00 ~ 18:00</span><span class="break-time">(점심)12:30 ~ 13:30</span>
					</div>
				</li>
			</ul>
		</div>

		<div class="tit_wrap">
			<img src="@/assets/img/icon/logo_footer.png" alt="KT alpha" />
			<span>사업자정보</span>
		</div>

		<div class="copyright">
			<span class="unit">㈜케이티알파</span>
			<span class="unit mg-l">대표이사 박승표</span>
			<span class="mg-l">개인정보보호책임자 한상봉</span><br />
			<span class="unit">사업자등록번호 211-81-79649</span><br />
			<span>통신판매업신고 제 2019-서울동작-0381호</span><br />
			<address>서울시 동작구 보라매로5길 23 삼성보라매 옴니타워 (07071)</address>
		</div>

		<ul class="sns-item-list">
			<li>
				<a
					href="https://m.blog.naver.com/ktalpha_giftishowbiz"
					target="_blank"
					class="btn-sns sns-blog"
					title="기프티쇼비즈 블로그(새창)"
					><span class="txt_hidden">BLOG</span></a
				>
			</li>
			<li>
				<a
					href="https://pf.kakao.com/_qxndLxb"
					target="_blank"
					class="btn-sns sns-kakao"
					title="기프티쇼비즈 카카오톡채널(새창)"
					><span class="txt_hidden">카카오톡채널</span></a
				>
			</li>
		</ul>

		<div class="link contents-article">
			<a href="https://www.ktalpha.com" target="_blank">
				<span class="txt">회사소개</span>
			</a>
			<a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=2118179649&apv_perm_no=200431900993020068" target="_blank"
				><span class="txt">사업자정보확인</span></a
			>
			<router-link to="/company/terms?termsTypeCd=PER">
				<span class="txt txt_red bold">개인정보처리방침</span>
			</router-link>
			<router-link to="/company/terms?termsTypeCd=SVC">
				<span class="txt">이용약관</span>
			</router-link>
		</div>

		<ul class="certification-logo-area">
			<li>
				<img src="@/assets/image/img/footer_ismsp@2x.png" class="isms" alt="isms-p" width="36" height="26" />
				<i
					>인증범위 및<br />
					유효기간 보기</i
				>
			</li>
			<!-- <li>
				<img
					src="@/assets/image/img/footer_csba_2022@2x.png"
					class="isms"
					alt="소비자만족 브랜드 대상 1위"
					width="28"
					height="28"
				/>
				<i
					>소비자만족<br />
					브랜드 대상 1위</i
				>
			</li>-->
			<!-- @추후 다른 상 받으면 쓸 수도 있어 주석처리. -->
			<!-- <li>
				<img
					src="@/assets/image/img/footer_fba_2023@2x.png"
					class="isms"
					alt="대한민국 퍼스트 브랜드 대상 1위"
					width="28"
					height="28"
				/>
				<i
					>대한민국 퍼스트<br />
					브랜드 대상 1위</i
				>
			</li> -->
			<li>
				<img
					src="@/assets/image/img/footer_ismsp_msg.png"
					class="isms"
					alt="대량문자 전송자격 인증"
					width="28"
					height="28"
				/>
				<i
					>대량문자<br />
					전송자격 인증</i
				>
			</li>
			<li>
				<img
					src="@/assets/image/img/footer_charge_safe.png"
					class="isms"
					alt="선불충전금 보호조치"
					width="36"
					height="36"
				/>
				<i
					>선불충전금<br />
					보호조치</i
				>
			</li>
		</ul>

		<div class="copyright">
			<p class="txt">Copyright ⓒ kt alpha Co., Ltd. All rights reserved.</p>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'Footer',
};
</script>

<style lang="less" scoped>
.ly_footer {
	.cs-operation {
		width: 260px;
		margin: 0 auto;
		text-align: left;
		li {
			.contact {
				.ico-bull {
					padding: 0 5px;
					margin-right: 4px;
				}
				.tel {
					margin-left: 8px;
				}
				&.panchok {
					margin-top: 1px;
					.line:after {
						content: '';
						display: inline-block;
						vertical-align: top;
						width: 1px;
						height: 11px;
						margin: 4px 8px 0;
						background-color: #e5e5e5;
					}
				}
			}
			.operating-hours {
				margin-left: 20px;
				.break-time {
					margin-left: 2px;
					color: #888;
				}
			}
		}
	}

	.sns-item-list {
		display: flex;
		gap: 12px;
		justify-content: center;
		.btn-sns {
			display: inline-block;
			vertical-align: top;
			width: 30px;
			height: 30px;
			background-repeat: no-repeat;
			background-position: 0 0;

			&.sns-blog {
				background-image: url('~@/assets/image/btn/btn_sns_blog_off.svg');
			}

			&.sns-kakao {
				background-image: url('~@/assets/image/btn/btn_sns_kakaotalk_off.svg');
			}
		}
	}
}
</style>
